// extracted by mini-css-extract-plugin
export default {"shell":"filter_shell__q80RF","shellMobile":"filter_shellMobile__7HQ7a","flexRow":"filter_flexRow__X19Fu","flexColumn":"filter_flexColumn__KSoqG"};